module.exports = __webpack_public_path__ + "static/media/1 08 herverk.369e49be.mp3";